import React from 'react';
import ListGroup from '../../Components/ListGroup';
import Heading from '../../Components/Heading';
import ImageBlurFallback from '../../Components/ImageBlurFallback';

import FREE_SPACE_PNG from '../../Assets/v2/ThreeHundred/FreeSpace.png';
import LIVE_PROJECTS_PNG from '../../Assets/v2/ThreeHundred/LiveProjects.png';
import INTERVIEW_PNG from '../../Assets/v2/ThreeHundred/Interview.png';
import PPO_PNG from '../../Assets/v2/ThreeHundred/PPO.png';
import SELF_PROJECT_PNG from '../../Assets/v2/ThreeHundred/SelfProject.png';

import FREE_SPACE_WEBP from '../../Assets/v2/ThreeHundred/FreeSpace.webp';
import LIVE_PROJECTS_WEBP from '../../Assets/v2/ThreeHundred/LiveProjects.webp';
import INTERVIEW_WEBP from '../../Assets/v2/ThreeHundred/Interview.webp';
import PPO_WEBP from '../../Assets/v2/ThreeHundred/PPO.webp';
import SELF_PROJECT_WEBP from '../../Assets/v2/ThreeHundred/SelfProject.webp';

import FREE_SPACE_FALLBACK from '../../Assets/fallbacks/ThreeHundred/FreeSpace.jpg';
import LIVE_PROJECTS_FALLBACK from '../../Assets/fallbacks/ThreeHundred/LiveProjects.jpg';
import INTERVIEW_FALLBACK from '../../Assets/fallbacks/ThreeHundred/Interview.jpg';
import PPO_FALLBACK from '../../Assets/fallbacks/ThreeHundred/PPO.jpg';
import SELF_PROJECT_FALLBACK from '../../Assets/fallbacks/ThreeHundred/SelfProject.jpg';

const FeatureCard = ({
  className,
  fallbackImage,
  image,
  webpImage,
  count = '',
  title = '',
  description = ''
}) => {
  return (
    <div className={`th-feature-card ${className}`}>
      <ImageBlurFallback
        className="th-feature-card-image"
        fallbackImage={fallbackImage}
        src={image}
        webpImage={webpImage}
      />

      <div className="th-feature-card-details">
        {!!count && <span className="th-feature-count">{count}+</span>}

        <span className="th-feature-title">{title}</span>
        <span className="th-feature-description">{description}</span>
      </div>
    </div>
  );
};

const Features = () => {
  return (
    <ListGroup
      containerClassName="th-features-container"
      title={
        <Heading
          className="th-features-heading"
          title="KEY FEATURES INCLUDES"
        />
      }
      center
      count={3}>
      <FeatureCard
        fallbackImage={LIVE_PROJECTS_FALLBACK}
        image={LIVE_PROJECTS_PNG}
        webpImage={LIVE_PROJECTS_WEBP}
        count="20"
        title="Live projects"
        description="In field of your choice"
      />
      <FeatureCard
        fallbackImage={INTERVIEW_FALLBACK}
        image={INTERVIEW_PNG}
        webpImage={INTERVIEW_WEBP}
        count="10"
        title="Mock Interviews"
        description="To get you ready"
      />

      <FeatureCard
        fallbackImage={SELF_PROJECT_FALLBACK}
        image={SELF_PROJECT_PNG}
        webpImage={SELF_PROJECT_WEBP}
        count="2"
        title="Self Projects"
        description="Guidance"
      />

      <FeatureCard
        fallbackImage={FREE_SPACE_FALLBACK}
        image={FREE_SPACE_PNG}
        webpImage={FREE_SPACE_WEBP}
        title="Free Space"
        description="To work for longer hours"
      />

      <FeatureCard
        fallbackImage={PPO_FALLBACK}
        image={PPO_PNG}
        webpImage={PPO_WEBP}
        title="Pre Placement Training"
        description="Assistance of relevant CS concepts"
      />
    </ListGroup>
  );
};

export default Features;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/Features.js